export default [
    {
        path: "/workshop",
        name: "workshop",
        component: () => import("@/pages/workshop/Workshop.vue"),
        meta: {
            pageTitle: "Pelatihan",
            icon: "icon-[ph--chalkboard-teacher-duotone]",
            layout: "LayoutUser",
            resource: "guest",
            // resource: "pelatihan",
            action: "read",
        },
    },
    {
        path: "/internal-workshop",
        name: "internalWorkshop",
        component: () => import("@/pages/workshop/InternalWorkshop.vue"),
        meta: {
            pageTitle: "Pelatihan Internal",
            icon: "icon-[ph--video-fill]",
            layout: "LayoutUser",
            resource: "pegawai",
            action: "read",
        },
    },
    
    {
        path: "/workshop/:ulid",
        name: "workshopDetail",
        component: () => import("@/pages/workshop/WorkshopDetail.vue"),
        meta: {
            pageTitle: "Detail Pelatihan",
            icon: "icon-[ph--chalkboard-teacher-duotone]",
            layout: "LayoutUser",
            resource: "guest",
            action: "read",
        },
    },

    {
        path: "/hiperlink/:ulid",
        name: "hiperlink",
        component: () => import("@/pages/hyperlink/hyperlink.vue"),
        meta: {
            pageTitle: "Hiperlink Pelatihan",
            icon: "icon-[ph--chalkboard-teacher-duotone]",
            layout: "LayoutUser",
            resource: "guest",
            action: "read",
        },
    },


    {
        path: "/workshop/:ulid/pre-test",
        name: "workshopPreTest",
        component: () => import("@/pages/workshop/WorkshopPrePostTest.vue"),
        meta: {
            pageTitle: "Pre Test Pelatihan",
            icon: "icon-[ph--chalkboard-teacher-duotone]",
            layout: "LayoutUser",
            resource: "pegawai",
            action: "read",
            pre_post: 0,
        },
    },
    {
        path: "/workshop/:ulid/video",
        name: "workshopInternalVideo",
        component: () => import("@/pages/workshop/WorkshopVideo.vue"),
        meta: {
            pageTitle: "Video Pelatihan",
            icon: "icon-[ph--chalkboard-teacher-duotone]",
            layout: "LayoutUser",
            resource: "pegawai",
            action: "read",
        },
    },
    {
        path: "/workshop/:ulid/post-test",
        name: "workshopPostTest",
        component: () => import("@/pages/workshop/WorkshopPrePostTest.vue"),
        meta: {
            pageTitle: "Post Test Pelatihan",
            icon: "icon-[ph--chalkboard-teacher-duotone]",
            layout: "LayoutUser",
            resource: "pegawai",
            action: "read",
            pre_post: 1,
        },
    },
    {
        path: "/workshop/:ulid/questionnaire",
        name: "workshopQuestionnaire",
        component: () => import("@/pages/workshop/WorkshopQuestionnaire.vue"),
        meta: {
            pageTitle: "Kuesioner Pelatihan",
            icon: "icon-[ph--chalkboard-teacher-duotone]",
            layout: "LayoutUser",
            resource: ["pegawai", "peserta"],
            action: "read",
            pre_post: 1,
        },
    },
    {
        path: "/workshop/:ulid/result",
        name: "workshopResult",
        component: () => import("@/pages/workshop/WorkshopInternalResult.vue"),
        meta: {
            pageTitle: "Hasil Pelatihan",
            icon: "icon-[ph--chalkboard-teacher-duotone]",
            layout: "LayoutUser",
            resource: "pegawai",
            action: "read",
        },
    },
];
